import React from 'react';
import './chapters.scss';
import Infographic from '../Infographic/Infographic';
import imageD from '../../assets/info2.jpg';
import imageM from '../../assets/info2-s.jpg';
import Hyperlink from '../Hyperlink/Hyperlink';
function Chapter3() {
  const infographicData = {
    caption: 'Intel, 2023',
    imageD: imageD,
    imageM: imageM,
    desc: "Today | Fixed-function, distributed, traditional | Today's cars have up to 100 Eletronic Control Units (ECUs), a mile of copper cabling and archaic legacy protocols to connect everything. | Future | Open, consolidated, software-defined, connected | Future vehicles will have fewer than 50 ECUs, high speed ethernet backbone for communication and will support ongoing feature updates over-the-air",
    src: 'Source'
  };
  const hyperlinkData = [
    {
      copy: 'virtualization',
      href: 'https://www.intel.com/content/www/us/en/business/enterprise-computers/resources/virtualization-security.html'
    },
    {
      copy: 'containerization',
      href: 'https://www.intel.com/content/www/us/en/cloud-computing/containers.html'
    },
    {
      copy: 'orchestration',
      href: 'https://www.intel.com/content/www/us/en/cloud-computing/cloud-orchestration.html'
    }
  ];

  return (
    <section className="chapters">
      <div className="chapters__copy">
        <h3>From Oil Changes to OTA Updates</h3>

        <p>
          The modern vehicle, Weast notes, “will be based on leading node high-performance
          semiconductors with a central compute SoC (system on a chip) being the heart of the
          vehicle. It will be flexible and software-defined rather than purpose-built, and it will
          embrace data center technologies like <Hyperlink hyperlinkData={hyperlinkData[0]} />,{' '}
          <Hyperlink hyperlinkData={hyperlinkData[1]} />, and{' '}
          <Hyperlink hyperlinkData={hyperlinkData[2]} />
          .”
        </p>
        <p>
          The move to a “central compute” model will also allow vehicles to incorporate AI and
          support a whole host of features and functions, such as Intelligent Energy Management,
          infotainment, driver monitoring systems (DMS), and more.
        </p>
        <p>
          As vehicles become “software-defined,” updates to that software will be as important as
          oil changes are for internal combustion engine (ICE) vehicles. But instead of going to a
          garage or dealership, these updates are delivered over the air (OTA) wherever your car is
          parked. The most essential components won't be the vehicle’s engine and transmission; they
          will be its semiconductors and software. Likewise, the mark of premium performance won’t
          be a vehicle’s horsepower; it will be its computing power and energy efficiency.
        </p>
        <p>
          That signifies a massive leap forward from what cars have needed to do up until this
          point, and yet, it is not unusual. Phones, televisions, and even household appliances have
          made similar technological leaps in the past 20 years as they have incorporated leading
          node microprocessors and become their own connected software platforms. Cars are poised to
          make a similar jump.
        </p>
      </div>
      <Infographic data={infographicData} />
    </section>
  );
}

export default Chapter3;
